<template>
  <div class="property-value" :title="data()">
    <a :href="data()" v-if="item.as === 'link'" target="_blank"
      >{{ data() != null && data() !== "" ? "Y aller" : item.placeholder }}
      {{ item.suffix }}</a
    >
    <span v-else-if="item.as === 'date' && data() != null && data() !== ''"
      >{{ data() | date }} {{ item.suffix }}</span
    >
    <span
      v-else-if="item.as === 'date' && !(data() != null && data() !== '')"
      >{{ item.placeholder }} {{ item.suffix }}</span
    >
    <span v-else
      >{{ data() != null && data() !== "" ? data() : item.placeholder }}
      {{ item.suffix }}</span
    >
  </div>
</template>

<script>

export default {
  props: ["item", "value"],
  methods: {
    rawData() {
      if (this.item.value) {
        return this.item.value();
      } else if (this.value) {
        let [a, b] = this.item.name.split(".");
        if (b != null) {
          return this.value[a] ? this.value[a][b] : "";
        } else {
          return this.value[a];
        }
      } else {
        return null;
      }
    },
    data: function() {
      let v = this.rawData();
      if (this.item.as === "select") {
        const [res] = this.item.items.filter(({ value }) => v === value);
        return res ? res.text : "-";
      }
      if (this.item.as === "staff") {
        const [res] = this.staff.filter(({ value }) => v === value);
        return res ? res.text : "-";
      }
      return v;
    }
  }
};
</script>
<style scoped>
.left {
  font-size: 11pt;
}
.right {
  width: 60%;
}
.property-value {
  font-size: 13px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  width: 100%;
}
@media screen and (min-width: 1024px) {
  .form-line-input {
    width: 400px;
  }
}

.invalid {
  color: darkorange;
  font-weight: bold;
}
</style>
